<div [formGroup]="detailsFormGroup">
  <div *ngIf="processorType === ProcessingTypes.YourCause"
    class="mb-3 me-4">
    <yc-i18n
      key="addOrg:textAddOrgDetailsHelp"
      defaultValue="Provide your organization's information, including contact details for a representative that can be added as a Nonprofit Administrator. They will be contacted about setting up the organization's Nonprofit Profile and applying for vetting. For more information about vetting, see the Help Center.">
    </yc-i18n>
    <yc-button
      [icon]="true"
      [tooltipText]="'common:textOpenHelpCenter' | ycI18n: 'Open help center'"
      [fontAwesomeIcon]="'arrow-up-right-from-square'"
      (onClick)="openHelpCenter()">
    </yc-button>
  </div>
  <div>
    <!-- Org Name -->
    <yc-input
      [label]="'common:labelOrganizationName' | ycI18n:'Organization name'"
      name="name"
      (onChange)="updateAddOrg('name', $event)">
    </yc-input>
  </div>
  <div>
    <!-- Website -->
    <yc-input
      [label]="'common:labelOrgContactWebsite' | ycI18n:'Organization website'"
      name="website"
      (onChange)="updateAddOrg('website', $event)">
    </yc-input>
  </div>
  <div *ngIf="captureVetting"
    class="d-flex">
    <!-- Full Name -->
    <div class="add-org-input me-3">
      <yc-input
        [label]="'common:labelContactFullName' | ycI18n:'Contact full name'"
        name="contactFullName"
        (onChange)="updateVettingContact('contactFullName', $event)">
      </yc-input>
    </div>

    <!-- Email -->
    <div class="add-org-input">
      <yc-input
        [label]="'common:labelContactEmail' | ycI18n:'Contact email'"
        name="contactEmail"
        (onChange)="updateVettingContact('contactEmail', $event)">
      </yc-input>
    </div>
  </div>

  <!-- Icon -->
  <yc-multi-dropzone-input
    name="image"
    [acceptedFileTypes]="acceptedFileTypes"
    [label]="'common:textIcon' | ycI18n : 'Icon'"
    [help]="'addOrg:textIconLogoHelp' | ycI18n: 'Add an icon or logo for the Nonprofit Profile that will be created. If none is provided, a generic icon will be used.'"
    (onChange)="setImage($event)">
  </yc-multi-dropzone-input>

</div>